export const TURNSTILE_PATH_RE = /\/api\/common\/convert-v\d+$/;
export const TURNSTILE_ERROR_RE = /turnstile/i;
export const TURNSTILE_BIZ_FAIL_CODE = 0;

export function isTurnstileProtectedUrl(url = "") {
  return TURNSTILE_PATH_RE.test(url);
}

export function isHumanVerificationDisabled(value) {
  // 兼容后端配置可能以布尔值、数字或字符串形式下发 false
  if (typeof value === "string") {
    return value.trim().toLowerCase() === "false" || value.trim() === "0";
  }
  return value === false || value === 0;
}

export function shouldResetTurnstile({
  url = "",
  data,
  failCode = TURNSTILE_BIZ_FAIL_CODE,
} = {}) {
  return (
    isTurnstileProtectedUrl(url) &&
    data &&
    data.code === failCode &&
    typeof data.message === "string" &&
    TURNSTILE_ERROR_RE.test(data.message)
  );
}
